import React, { useState, useEffect } from 'react'
import { Box, Flex, Group, Button, Textarea, TagsInput } from '@mantine/core'
import { addFaq, updateFaq } from '../../../services/faq'
import { useFaqForm } from './schema/form'
import { notificationSuccess, notificationError } from '../../ui/Notifications'

const FormAdjustFaq = ({ dataFaq, onCloseForm, reloadList }) => {
  const [loadingForm, setLoadingForm] = useState(false)

  const form = useFaqForm()

  const submitFaq = async (form) => {
    setLoadingForm(true)
    let methodFunction = null
    let titleMessageSuccess = ''
    let captionMessageSuccess = ''
    let titleMessageError = ''
    let captionMessageError = ''

    if (dataFaq !== null) {
      methodFunction = updateFaq(dataFaq.id, form)
      titleMessageSuccess = 'Update FAQ Success'
      captionMessageSuccess = 'FAQ has been updated successfully.'
      titleMessageError = 'Update FAQ Failed'
      captionMessageError = 'FAQ failed to update, please try again.'
    } else {
      methodFunction = addFaq(form)
      titleMessageSuccess = 'Create FAQ Success'
      captionMessageSuccess = 'FAQ has been created successfully.'
      titleMessageError = 'Create FAQ Failed'
      captionMessageError = 'FAQ failed to create, please try again.'
    }

    try {
      const response = await methodFunction
      if (response.success) {
        notificationSuccess(titleMessageSuccess, captionMessageSuccess)
        setLoadingForm(false)
        reloadList()
        onCloseForm()
      }
    } catch (error) {
      const errorMessage = error.response.data.message
      notificationError(titleMessageError, errorMessage ? errorMessage : captionMessageError)

      const errorMessageForm = error.response.data.errors
      if (errorMessageForm) {
        Object.keys(errorMessageForm).forEach((key) => {
          form.setFieldError(key, errorMessageForm[key][0])
        })
      }
      setLoadingForm(false)
    }
  }

  useEffect(() => {
    if (dataFaq !== null) {
      handleSetForm(dataFaq)
    }
    // eslint-disable-next-line
  }, [dataFaq])

  const handleSetForm = (data) => {
    const detail = {
      question: data.question || '',
      answer: data.answer || '',
      keyword: data.keyword || [],
    }

    form.initialize(detail)
    form.setValues(data)
  }

  return (
    <Box>
      <Box mb='sm'>
        <Textarea
          name='question'
          label="Question"
          placeholder="Input question here"
          {...form.getInputProps('question')}
          size='xs'
          autosize
          minRows={2}
          maxRows={2}
          withAsterisk
        />
      </Box>
      <Box mb='sm'>
        <Textarea
          name='answer'
          label="Answer"
          placeholder="Input answer here"
          {...form.getInputProps('answer')}
          size='xs'
          autosize
          minRows={2}
          maxRows={2}
          withAsterisk
        />
      </Box>
      <Box mb='sm'>
        <TagsInput
          name='keyword'
          label="Keywords"
          description="Press enter to add keyword"
          {...form.getInputProps('keyword')}
          size='xs'
          withAsterisk
        />
      </Box>
      <Box mt={20}>
        <Flex justify='flex-end'>
          <Group>
            <Button size='xs' variant="outline" onClick={onCloseForm}>Close</Button>
            <Button size='xs' loading={loadingForm} variant="filled" onClick={form.onSubmit((value) => submitFaq(value))}>{dataFaq !== null ? 'Update' : 'Create'}</Button>
          </Group>
        </Flex>
      </Box>
    </Box>
  )
}

export default FormAdjustFaq